import { ColumnDataType, ConfigurationColumn } from "src/app/shared/model/resource";

export const acessoPessoalFormResource: ConfigurationColumn[] = [
    {
        field: 'nome',
        label: 'Nome',
        type: ColumnDataType.Text,
        required: true,
        sizeColumn: 'col-12'
    },
    {
        field: 'username',
        label: 'Email',
        type: ColumnDataType.Text,
        required: true,
        sizeColumn: 'col-12'
    },
    {
        field: 'cpf',
        label: 'CPF',
        type: ColumnDataType.Number,
        sizeColumn: 'col-12'
    },
    {
        field: 'telefone',
        label: 'Telefone',
        type: ColumnDataType.Number,
        sizeColumn: 'col-12'
    },
]